import { types } from 'mobx-state-tree'
import { WorkspaceResponse } from './WorkspaceResponse'

export const MagicLinkResponse = types.model('MagicLinkResponse').props({
  token: types.string,
  workspaces: types.array(WorkspaceResponse),
})
